import { useMutation } from '@apollo/react-hooks';
import { REQUEST_TRIAL_CHANNEL_SUBSCRIPTION } from '../../gql/subscriptions';
import { useLogger } from '../providers/logger/Logger';
import { LogAction, LogLevel } from '../providers/logger/logger-types';

type Request = (channelId: string) => Promise<any>;

export const useRequestFreeTrial = (): [Request, boolean] => {
	const { printLog } = useLogger();
	const [requestTrialChannelSubscription, { loading }] = useMutation(REQUEST_TRIAL_CHANNEL_SUBSCRIPTION);
	const request: Request = (channelId: string) => requestTrialChannelSubscription({
		variables: {
			item: {
				channelId: channelId
			}
		}
	}).then(response => {
		if (response.data) {
			window.Appcues?.track('RequestedTrialPremiumChannel', {
				channelName: response.data.requestTrialChannelSubscription.channelName,
				userEmail: response.data.requestTrialChannelSubscription.userEmail
			});
		}
		return response;
	}).catch(e => {
		printLog(
			LogLevel.ERROR,
			LogAction.RegisteredInterestPremiumChannel,
			'Cannot request trial in channel',
			e);
		throw e;
	});

	return [request, loading];
}